import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { useTranslation } from "react-i18next";
import { useFormikContext } from 'formik';


const RadioFormItem = ({
  name,
  schema,
  hint,
  required = false,
  errorMessage,
  inputProps,
}) => {
  const { t } = useTranslation();
  
  const [field, meta, helpers] = useField(name);

  const { label, options } = schema[name];

  const { submitCount } = useFormikContext();
  const showError = (meta.touched || submitCount > 0) && meta.error;

  return (
    <div className="form-group">
      {!!label && (
        <label className={`col-form-label ${required ? 'required' : ''}`}>
          {t(label)} {required ? <span className="text-danger">*</span> : ''}
        </label>
      )}

      <br />

      <div className={`${showError ? 'is-invalid' : ''}`}>
      {options.map((option) => (
        <div key={option.value}>

        <div  className="form-check form-check-inline">
          <input
            className={`form-check-input`}
            type="radio"
            id={`${name}-${option.value}`}
            name={name}
            value={option.value}
            checked={field.value === option.value}
            onChange={() => helpers.setValue(option.value)}
            onBlur={() => helpers.setTouched(true)}
            {...inputProps}
          />
          <label htmlFor={`${name}-${option.value}`} className="form-check-label">
            {t(option.label)}
          </label>
        </div>
        {!!option?.helpText && <div className="mb-2 ms-4"><small className="form-text text-muted">{t(option.helpText)}</small></div>}
        </div>
      ))}
      </div>

      {showError && (
        <div className="invalid-feedback">{t(errorMessage || meta.error)}</div>
      )}

      {!!hint && <small className="form-text text-muted">{t(hint)}</small>}
    </div>
  );
};

export default RadioFormItem;
